/**
 * Token configuration constants
 * Centralized configuration to avoid magic numbers and inconsistencies
 */

export const TOKEN_CONFIG = {
  // Team token expiry time: 15 minutes (for tokens from /auth/grant - team switching and refresh)
  TEAM_TOKEN_EXPIRY_MS: 15 * 60 * 1000,

  // Refresh threshold: when remaining time < 2 minutes, proactively refresh
  TEAM_TOKEN_REFRESH_THRESHOLD_MS: 2 * 60 * 1000,

  // Login token expiry time: 7 days (for tokens from /api/login with scope=Team)
  LOGIN_TOKEN_EXPIRY_MS: 7 * 24 * 60 * 60 * 1000,

  // Login token cookie expiry: 7 days
  LOGIN_TOKEN_COOKIE_EXPIRY_DAYS: 7,

  // Maximum retry attempts for token refresh
  MAX_TOKEN_REFRESH_RETRIES: 3,
} as const

/**
 * Generate stable request ID based on URL and HTTP method
 * Uses normalized URL (without query params) and uppercase method
 * This ensures the same endpoint always gets the same ID for retry tracking
 *
 * @param url - Request URL
 * @param method - HTTP method
 * @returns Stable request identifier
 */
export function generateStableRequestId(url?: string, method?: string): string {
  // Normalize URL by removing query parameters and trailing slashes
  const normalizedUrl = url?.split('?')[0]?.replace(/\/$/, '') || 'unknown'

  // Normalize method to uppercase
  const normalizedMethod = method?.toUpperCase() || 'GET'

  return `${normalizedMethod}:${normalizedUrl}`
}

/**
 * Type guard to validate if a value is a valid LoginSource
 */
export function isValidLoginSource(value: unknown): value is string {
  return typeof value === 'string' && (value === 'platform' || value === 'team')
}
